import React, {useEffect, useState} from 'react';
import SelectCustom2 from "../../../../shared/ui/form/select2/Select2";
import {useSelector} from "react-redux";
import {selectPharmacies} from "../../../../core/reducer/auth/authSlice";
import FormGroupCustom from "../../../../shared/ui/form/FormGroupCustom";
import {typeHoursInitArray} from "../../../../common/typeHours";
import {selectSelectedPharmacy} from "../../../../core/reducer/pharmacySlice";

const ElementCompanyHoursEdit = ({
                                     changeValue,
                                     dataForm,
                                     errors
                                 }: {
    dataForm?: any;
    errors: any;
    changeValue: (data: any) => void
}) => {
    const selectedPharmacy = useSelector(selectSelectedPharmacy);
    const isTimeBank = !!selectedPharmacy?.timeBank;

    const pharmacies = useSelector(selectPharmacies);
    const [pharmaciesOpt, setPharmaciesOpt] = useState<any[]>([])

    useEffect(() => {
        setPharmaciesOpt((pharmacies || [])?.map(ele => ({label: ele.name, value: ele?.idDocument})))
    }, [pharmacies]);


    const columns: { name: string, label: string } [] = [
        ...typeHoursInitArray.map(ele => ({
            label: (ele.timeBank && ele.timeBank !== isTimeBank) ? 'Straordinario' : ele.label,
            name: ele.name
        }))
    ]

    return (
        <>
            <div className={'d-flex justify-content-between align-items-baseline pb-2'}>
                Puoi modificare le ore di pertinenza del dipendente dell'azienda.
            </div>
            <div
                className={" form-element-company d-flex flex-column gap-2 mb-4"}>
                <div className={"d-flex gap-2"}>
                    <div className={'w-100'}>
                        <SelectCustom2
                            options={pharmaciesOpt}
                            value={dataForm[`idPharmacy`]}
                            changeValue={(val: any) =>
                                changeValue({name: `idPharmacy`, value: val})
                            }
                            error={errors[`idPharmacy`]}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className={'d-flex w-100'}>
                    <table className={'table-hours-comp'}>
                        <thead>
                        <tr>
                            {columns.map(col => <th style={{maxWidth: '110px'}}>{col.label}</th>)}
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            {columns.map(col => <td style={{maxWidth: '110px'}}>
                                    <FormGroupCustom
                                        key={col.name}
                                        structure={{
                                            name: col.name,
                                            type: 'input',
                                            dataElement: {type: 'text'},
                                            col: {xs: 12},
                                        }}
                                        value={dataForm[col.name] || ''}
                                        isSubmit={true}
                                        dataForm={dataForm}
                                        changeValue={changeValue}
                                        errors={errors}
                                    />
                                </td>
                            )}
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </>
    );
};

export default ElementCompanyHoursEdit;
